import React, { createContext, useEffect, useState } from "react";

// Creating Auth Context
export const AuthContext = createContext();

export default function AuthProvider({ children }) {

    // Getting the jwt token from the local storage and saving it in state
    const [token, setToken] = useState(localStorage.getItem("JWTToken") || "");

    // For Routes Validation
    const [isTokenValid, setIsTokenValid] = useState(false);

    // State for user data coming from the server if the token is verified
    const [authorizeUserData, setAuthorizeUserData] = useState();

    // If token is given by the server set it in the local storage
    const storeTokenInLS = (token) => {
        setToken(token);
        return (
            localStorage.setItem("JWTToken", token)
        );
    }

    // If the user click the logout button the token should be removed from the client side
    const logoutUser = () => {
        setToken("");
        setAuthorizeUserData("");
        setIsTokenValid(false);
        return (
            localStorage.removeItem("JWTToken")
        );
    }

    // Authorizing the user if the token is valid
    const authorizeUser = async () => {
        try {
            const response = await fetch("https://hotelbnb-backend.onrender.com/authorize", {
                "method": "GET",
                headers: {
                    "Authorization": `Bearer ${token}`,
                },
            });

            if (response.ok) {
                const result = await response.json();
                setAuthorizeUserData(result);
                setIsTokenValid(true);
            }

        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        authorizeUser();
    }, [token]);

    return (
        <AuthContext.Provider value={{ storeTokenInLS, logoutUser, token, isTokenValid, setIsTokenValid, authorizeUserData, setAuthorizeUserData }}>
            {children}
        </AuthContext.Provider>
    )
}